<template lang="pug">
div
  .md-headline Language
  md-input-container
    label Language
    md-select#input-language(v-model='entity.language')
      md-option(v-for='(name, code) in languageNames', :key='code', :value='code') {{ name }}
</template>

<script>
import languageNames from '../../common/utils/languageValidator';

export default {
  computed: {
    languageNames() {
      return languageNames;
    }
  },
  props: {
    entity: {
      type: Object,
      required: true
    }
  },
  mounted() {
    if (!this.entity.language) {
      this.$set(this.entity, 'language', 'en');
    }
  }
};
</script>

<style lang="scss" scoped>
.md-headline {
  margin-bottom: 15px;
}
</style>



// WEBPACK FOOTER //
// src/shared-components/forms/LanguageForm.vue